import BaseCtrl from 'edge/platform/base/BaseCtrl';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

const fn = ($filter, $scope, $state, $stateParams, $window, $location, ModalService, AccountService, NewAccountService, defaultLocaleDetails, ViewModelService, InsuranceSuiteMetadata, UserInfoService) => {
    const ctrl = Object.create(BaseCtrl);
    const countryTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('Country');

    ctrl.init = () => {
        $scope.hideFields = ['Province','AddressLine1', 'AddressLine2', 'AddressLine3'];
        $scope.defaultHiddenFields = ['Prefix', 'Suffix', 'MiddleName', 'Particle'];
        if ($stateParams.accountNumber && $stateParams.accountNumber.length > 0) {
            $scope.accountNumber = $stateParams.accountNumber;
            $scope.isExistingAccount = true;
        } else {
            $scope.isExistingAccount = false;
        }

        $scope.userDefaultCountry = UserInfoService.user.userDefaultCountry_PSA; // PSA
        const defaultCountryCode = null; // PSA - allow world-wide search $scope.userDefaultCountry || $scope.defaultCountryCode || defaultLocaleDetails.countryCode;

        $scope.showResults = false;
        $scope.showResultsTable = false;

        $scope.accountSearchCriteria = {};
        $scope.accountSearchCriteria.country = defaultCountryCode;
        $scope.accountSearchCriteriaView = ViewModelService.create($scope.accountSearchCriteria, 'pc', 'edge.capabilities.gateway.account.search.dto.AccountSearchCriteriaDTO');

        $scope.potentialAccounts = [];

        $scope.newAccount = {
            ProducerCode: '100-002541'
        };
        $scope.newAccount.AccountHolder = {};

        $scope.showAccessAlert = true;

        $scope.hideAccessAlert = () => {
            $scope.showAccessAlert = false;
        };

        const applicationFeatures = ApplicationFeatures.getAllFeatures();
        $scope.accountTypes = applicationFeatures.accountTypes;
        $scope.accountSearchCriteria.contactType = applicationFeatures.accountTypes[0];
        ctrl.setLinkEntryFields();
    };

    ctrl.setLinkEntryFields = function () {
        $scope.url = decodeURIComponent($location.url());
        if (typeof $scope.url === 'string' && $scope.url.split('?').length > 1) {
            let params = $scope.url.split('?');
            let eachParamsArr = params[1].split('&');
            $scope.urlParams = {};
            if (eachParamsArr && eachParamsArr.length) {
                eachParamsArr.map(param => {
                    let keyValuePair = param.split('=')
                    let key = keyValuePair[0];
                    let value = keyValuePair[1].replaceAll("+", " ");
                    $scope.urlParams[key] = value;
                })
            }
            if ($scope.urlParams.FirstName != undefined) {
                //console.log("URL :" + $location.$$url);
                //console.log(JSON.stringify($location.search()));
                if($scope.urlParams.Beneficiary === 'Person'){
                    $scope.accountSearchCriteria.contactType = 'person';
                    //INCI11646637 | THE PHONE NUMBER FOR ITALY IS BLOCKING THE SUBSCRIPTION
                    $scope.accountSearchCriteria.firstName = $scope.urlParams.FirstName ?  $scope.urlParams.FirstName :undefined;
                    $scope.accountSearchCriteria.lastName = $scope.urlParams.LastName ? $scope.urlParams.LastName:undefined;
                } else {
                    $scope.accountSearchCriteria.contactType = 'company';
                    //INCI11646637 | THE PHONE NUMBER FOR ITALY IS BLOCKING THE SUBSCRIPTION
                    $scope.accountSearchCriteria.contactName = $scope.urlParams.LastName ? $scope.urlParams.LastName : undefined;
                }
                $scope.accountSearchCriteria.city = $scope.urlParams.City;
                $scope.accountSearchCriteria.country = $scope.urlParams.Country;
                $scope.accountSearchCriteria.postalCode = $scope.urlParams.ZipCode;
                $scope.accountSearchCriteria.addressLine1 = $scope.urlParams.AddressNumber +" "+$scope.urlParams.Address;
                //INCI11646637 | THE PHONE NUMBER FOR ITALY IS BLOCKING THE SUBSCRIPTION
                $scope.accountSearchCriteria.workNumber = $scope.urlParams.Telephone ?  $scope.urlParams.Telephone : undefined;
                $scope.accountSearchCriteria.cellNumber = $scope.urlParams.Mobile ? $scope.urlParams.Mobile : undefined;
                $scope.accountSearchCriteria.emailAddress1 = $scope.urlParams.Email.replace("%","@");
                 $scope.accountSearchCriteria.fiscalCode = $scope.urlParams.FiscalCode;
                $scope.accountSearchCriteria.prefix = $scope.urlParams.Prefix ?  $scope.urlParams.Prefix :undefined;
                $scope.accountSearchCriteria.url = JSON.stringify($scope.urlParams);
            }
        }
    }

    ctrl.setCancelState = () => {
        const title = 'gateway.controllers.NewQuoteCtrl.Cancel Quote';
        const msg = 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the new quote?';
        const description = null;

        const cancelDialogPromise = ModalService.showWarning(title, msg, description, $filter('translate')('gateway.views.modal.Yes'), 'gw-btn-primary', $filter('translate')('gateway.views.modal.No')).result;
        cancelDialogPromise.then(() => {
            window.history.back();
        });
    };

    ctrl.setNextState = (form) => {
        form.submitted = true;
        if (form.invalid) {
            return;
        }

        $scope.queryExistingAccounts();
    };


    ctrl.newQuote = (accountNumber) => {
        const state = $state.get('newQuote');
        NewAccountService.AccountSearchCriteria = $scope.accountSearchCriteria;
        if (!angular.isDefined(accountNumber)) {
            $state.transitionTo(state);
        } else {
            $state.transitionTo(state, {
                accountNumber
            });
        }
    };

    ctrl.resetSearch = () => {
        $scope.showResults = false;
    };

    ctrl.queryExistingAccounts = () => {
        const ExistingAccountQueryPromise = AccountService.getPotentialExistingAccounts($scope.accountSearchCriteria);
        $scope.existingAccountQueryPromise = ExistingAccountQueryPromise;

        ExistingAccountQueryPromise.then((potentialExistingAccounts) => {
            $scope.potentialAccounts = potentialExistingAccounts;
            $scope.showResults = true;

            $scope.showResultsTable = !!(potentialExistingAccounts && potentialExistingAccounts.length > 0);
        }, () => {
            ModalService.showError('gateway.views.modal.Error', 'gateway.views.modal.Error.Data');
        });
    };

    ctrl.getCountry = (countryCode) => {
        return countryTypelist.getCode(countryCode).name;
    };

    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$window', '$location', 'ModalService', 'AccountService', 'NewAccountService', 'defaultLocaleDetails', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService'];
export default fn;